// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3idPd","large":"styles_large__2Xpij"};